<template>
  <button
    :disabled="loading"
    :class="[
      'flex items-center justify-center rounded-md border border-transparent bg-neutral-50 px-4 py-2 text-sm font-normal text-primary-500 hover:bg-primary-50 focus:outline-hidden focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ',
      loading ? ['bg-primary-50 hover:bg-primary-50'] : '',
      className,
    ]"
    @click="action"
  >
    <TIcon v-if="loading" name="loader" class="mr-2 h-5 w-5 animate-spin" />
    <span v-if="!loading">
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  loading?: boolean;
  action?: () => void;
  className?: string;
}>();
</script>
